import { render } from "./CadastroDadosPessoais.vue?vue&type=template&id=81351d86&scoped=true&lang=html"
import script from "./CadastroDadosPessoais.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroDadosPessoais.vue?vue&type=script&setup=true&lang=js"

import "./CadastroDadosPessoais.vue?vue&type=style&index=0&id=81351d86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81351d86"]])

export default __exports__